var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"mt-0 pt-0",staticStyle:{"background-color":"white"}},[_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }